import { Flex } from "styles/utility-components";

import FilterableBidResponses from "components/bid_module/bid-response/FilterableBidResponses";
import { BreadcrumbContainer, RouterBreadcrumb } from "components/ui/breadcrumb/SimpleBreadcrumb";
import { useBid } from "lib/hooks/api/bid/bids/useBid";
import { BidResponseSortBy, BidResponseSortOrder } from "lib/types/graphQLEnums";

type Props = {
  bidId?: string | undefined;
};

export function BidResponsesListPage({ bidId }: Props) {
  const { data: bid, isLoading: isLoadingBid } = useBid({ id: bidId ?? "" }, { enabled: !!bidId });

  return (
    <Flex column height="100%" width="100%">
      {bidId && (
        <BreadcrumbContainer>
          <RouterBreadcrumb
            overrides={{
              [`/bids/${bidId}`]: { label: bid?.name || "Bid", isLoading: isLoadingBid },
            }}
          />
        </BreadcrumbContainer>
      )}
      <FilterableBidResponses
        bidId={bidId}
        bidName={bid?.name}
        defaultFilters={{
          bidId,
          // Across bids the table is a task list, so the soonest due comes first and
          // undated questions fall to the bottom.
          ...(bidId
            ? { orderBy: BidResponseSortBy.CreatedAt, order: BidResponseSortOrder.Desc }
            : { orderBy: BidResponseSortBy.DueDate, order: BidResponseSortOrder.Asc }),
        }}
      />
    </Flex>
  );
}

export const BidResponsesPage = BidResponsesListPage;
